import React from "react";
import Link from "gatsby-link";

const Header = ({ siteTitle }) => (
  null
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/header.js